import React from 'react'
import { Link } from "react-router-dom";
function Personaldetails() {
    return (
        <section>
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-lg-4">
                        <div className="card boxed">
                            <div className="card-header">
                                <ul className="nav nav-tabs nav-fill card-header-tabs lavalamp" id="component-1" role="tablist">
                                    <li className="nav-item">
                                        <a className="nav-link active" data-toggle="tab" href="#component-1-1" role="tab" aria-controls="component-1-1" aria-selected="true">Personal Details</a>
                                    </li>

                                </ul>
                            </div>
                            <div className="card-body">
                                <div className="tab-content" id="component-1-content">
                                    <div className="col-12 py-1" style={{fontSize:"90%"}}><small>Please provide the following details.</small></div>
                                    <div className="tab-pane fade show active" id="component-1-1" role="tabpanel" aria-labelledby="component-1-1">
                                        <div className="row gutter-2">
                                            <div className="col-12">
                                                <fieldset>
                                                    <div className="row">
                                                        <div className="col-12">
                                                            <div className="form-label-group">
                                                                <input type="text" id="inputPhone" className="form-control form-control-lg" placeholder="Email address" required="" maxlength="10" />
                                                                <label for="inputPhone">Enter your name</label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-12">
                                                            <div className="form-label-group">
                                                                <input type="text" id="inputEmail2" className="form-control form-control-lg" placeholder="Password" required="" />
                                                                <label for="inputPassword">Enter your email</label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </fieldset>
                                                <div className="custom-control custom-checkbox mt-3">
                                                    <input type="checkbox" id="customCheckbox1" name="customCheckbox1" className="custom-control-input" />
                                                    <label className="custom-control-label text-muted" for="customCheckbox1">I agree to the <a href="" className="underline">Terms and Conditions</a></label>
                                                </div>
                                            </div>


                                            <div className="col-12">
                                                <Link to="/new-subscription" className="btn btn-primary btn-block">Proceed</Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Personaldetails
